import { useQuery } from '@tanstack/react-query';
import { configService } from '../../../services/ConfigService';
import { queryKeys } from '../../../lib/queryKeys';
import { useAuth } from '@/hooks/useAuth';
import { API_CONFIG } from '@/config/api';

export function useEntityTypes() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: queryKeys.entityTypes.all,
    queryFn: () => configService.getEntityTypes(),
    staleTime: API_CONFIG.CACHE_STALE_TIME_MS,
    enabled: isAuthenticated,
  });
}

export function useEntityTypeConfig(entityType: string) {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: queryKeys.entityTypes.config(entityType),
    queryFn: () => configService.getEntityTypeConfig(entityType),
    enabled: Boolean(entityType) && isAuthenticated,
    staleTime: API_CONFIG.CACHE_STALE_TIME_MS,
  });
}
